import { Staffs } from '../../types';

export const StaffsPages = Staffs.Pages;
